export default {
  app: {
    golf: {
      title: 'Informations sur le parcours',
      hasEVChargingPoint: 'Point de recharge pour véhicules électriques',
      hasCaddieService: 'Service de caddie',
      hasTrolley: 'Chariot',
      hasBuggy: 'Buggy',
      hasClubRental: 'Location de clubs',
      hasAcademy: 'Académie',
      hasMarshal: 'Marshal',
      hasPGACertification: 'Certification PGA',
      hasTrainingArea: "Zone d'entraînement",
      hasRestaurant: 'Restaurant',
      hasHotel: 'Hôtel',
      hasDogsOnCourse: 'Chiens sur le parcours',
      numberOfHoles: 'Nombre de trous',
    },
  },
};
